import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const ReturnPortalSelector = ({ returnPortals, onChange, value }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Selecciona la tienda')}
      menuItems={returnPortals?.map(s => ({ label: s?.selector_message || s.name, value: s.slug }))}
      handleChange={e => onChange(e.target.value)}
      fullWidth
      value={value}
    />
  )
}

export default ReturnPortalSelector
